import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from '../../axios';

const MajorModal = ({ show, onHide, currentAcademicYear, major }) => {
  const [formData, setFormData] = useState({
    academicYear: currentAcademicYear,  // Set mặc định bằng giá trị currentAcademicYear truyền vào
    majorCode: '',
    majorName: '',
    expectedClassCount: '', 
    maxStudentsPerClass: '', 
    classPrefix: '' 
  });

  useEffect(() => {
    if (major) {
      setFormData({
        academicYear: major.academicYear || currentAcademicYear,  // Sử dụng giá trị từ major nếu có, nếu không dùng currentAcademicYear
        majorCode: major.majorCode,
        majorName: major.majorName,
        expectedClassCount: major.expectedClassCount, 
        maxStudentsPerClass: major.maxStudentsPerClass, 
        classPrefix: major.classPrefix 
      });
    }
  }, [major, currentAcademicYear]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (major) {
        await axios.put(`/majors/${major._id}`, formData);
      } else {
        await axios.post('/majors', formData);
      }
      onHide();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{major ? 'Edit Major' : 'Add Major'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formMajorCode">
            <Form.Label>Major Code</Form.Label>
            <Form.Control
              type="text"
              name="majorCode"
              value={formData.majorCode}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="formMajorName">
            <Form.Label>Major Name</Form.Label>
            <Form.Control
              type="text"
              name="majorName"
              value={formData.majorName}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="formExpectedClassCount">
            <Form.Label>Number of Expected Classes</Form.Label>
            <Form.Control
              type="number"
              name="expectedClassCount"
              value={formData.expectedClassCount}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="formMaxStudentsPerClass">
            <Form.Label>Max Students per Class</Form.Label>
            <Form.Control
              type="number"
              name="maxStudentsPerClass"
              value={formData.maxStudentsPerClass}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="formClassCodePrefix">
            <Form.Label>Class Code Prefix</Form.Label>
            <Form.Control
              type="text"
              name="classPrefix"
              value={formData.classPrefix}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            {major ? 'Update Major' : 'Add Major'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default MajorModal;
